import { ThemeProvider } from 'styled-components'
import { useDarkMode } from './Theme.hook'
import { lightTheme } from './light.theme'
import { darkTheme } from './dark.theme'
import GlobalStyle from './globalStyle'

const AppThemeProvider = ({ children }) => {
  const { theme } = useDarkMode()

  const selectedTheme = theme === 'dark' ? darkTheme : lightTheme

  return (
    <ThemeProvider theme={selectedTheme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default AppThemeProvider
